<template>
  <div class="main-content">
    <div class="center-body">
      <!-- <div class="row">
        <div
          class="nav-title col-no"
          style="width: 240px; justify-content: center; align-items: center;"
        >
          <div style="font-size: 14px; color: #012f8f;">
            上海新龙塑料制造有限公司
          </div>
          <div style="font-size: 14px; color: #012f8f;">SHANGHAIXINLONG</div>
        </div>
        <div>
          <Menu mode="horizontal" @on-select="route" :active-name="1">
            <Menu-item :name="1">
              {{ $t("lang.home") }}
            </Menu-item>
            <Menu-item :name="2">
              {{ $t("lang.newsinfo") }}
            </Menu-item>
            <Menu-item :name="3">
              {{ $t("lang.cmpintr") }}
            </Menu-item>
            <Menu-item :name="4">
              {{ $t("lang.newproduct") }}
            </Menu-item>
            <Menu-item :name="5">
              {{ $t("lang.downloadcenter") }}
            </Menu-item>
          </Menu>
        </div>
        <div
          class="item"
          style="
            justify-content: flex-end;
            align-items: center;
            padding-right: 25px;
          "
        >
          <div
            :style="{ color: langCn }"
            style="cursor: pointer; font-size: 16px; padding-right: 5px;"
            @click="toCN"
          >
            {{ $t("lang.zw") }}
          </div>
          |
          <div
            :style="{ color: langEn }"
            style="cursor: pointer; font-size: 16px; padding-left: 5px;"
            @click="toEN"
          >
            {{ $t("lang.yw") }}
          </div>
        </div>
      </div> -->
      <Nav />
      <Carousel v-model="swiperIndex" loop autoplay :autoplay-speed="4000">
        <template v-for="list in bannerForm">
          <CarouselItem :key="list.id">
            <img :src="list.pic" style="width: 100%;" />
          </CarouselItem>
        </template>
      </Carousel>
      <div class="prduct-box">
        <!-- <div class="row"> -->
        <div class="title">
          <h2>{{ $t("lang.productcenter") }}</h2>
          <p>{{ $t("lang.productcenter1") }}</p>
          <span style="cursor: pointer;" @click="toFilter">
            {{ $t("lang.more") }} <i>>></i>
          </span>
        </div>
        <!-- <div class="item" style="font-size: 20px;color: #333;font-weight: 600;">{{$t('lang.product')}}</div> -->
        <!-- <div class="item" style="justify-content: flex-end;color: rgb(22, 155, 213);align-items: center;">
            <span style="cursor: pointer;" @click="toFilter">{{$t('lang.productcenter')}} ></span>
          </div> -->
        <!-- </div> -->
        <div class="wrap-row" style="margin-bottom: 15px;">
          <div
            class="col-no"
            style="width: 23%; margin: 0 1%; margin-top: 15px;"
            v-for="list in productList"
            @click="toClass(list)"
            :key="list.id"
          >
            <div
              class="pro-imgbox"
              style="width: 100%; height: 270px; overflow: hidden;"
            >
              <img :src="list.pic" style="width: 100%; height: 270px;" />
            </div>
            <div
              class="item"
              style="
                justify-content: center;
                font-size: 14px;
                color: #333;
                font-weight: 400;
                margin-top: 10px;
                overflow: hidden;
              "
            >
              {{ list.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="auth">
        <div class="prduct-box">
          <div class="title">
            <h2>{{ $t("lang.authentication") }}</h2>
            <p>{{ $t("lang.authentication1") }}</p>
          </div>
          <!-- <div class="row" style="font-size: 20px;color: #333;font-weight: 600;">
            {{$t('lang.authentication')}}
          </div> -->
          <div class="wrap-row" style="margin-bottom: 25px;">
            <div class="col-no aut-box">
              <img src="../../assets/img/u48.png" style="width: 100%;" />
            </div>
            <!-- <div class="col-no aut-box">
              <img src="../../assets/img/u52.png" style="width: 100%;" />
            </div> -->
            <div class="col-no aut-box">
              <img src="../../assets/img/u54.png" style="width: 100%;" />
            </div>
            <div class="col-no aut-box">
              <img src="../../assets/img/u53.png" style="width: 100%;" />
            </div>
            <div class="col-no aut-box">
              <img src="../../assets/img/u51.png" style="width: 100%;" />
            </div>
            <div class="col-no aut-box">
              <img src="../../assets/img/u49.png" style="width: 100%;" />
            </div>
            <div class="col-no aut-box">
              <img src="../../assets/img/u47.png" style="width: 100%;" />
            </div>
            <div class="col-no aut-box">
              <img src="../../assets/img/u50.png" style="width: 100%;" />
            </div>
            <div class="col-no aut-box">
              <img src="../../assets/img/u56.jpg" style="width: 100%;" />
            </div>
            <div class="col-no aut-box">
              <img src="../../assets/img/u555.jpg" style="width: 100%;" />
            </div>
            <div class="col-no aut-box">
              <img src="../../assets/img/u57.png" style="width: 100%;" />
            </div>
          </div>
        </div>
      </div>
      <div class="prduct-box">
        <div class="title">
          <h2>{{ $t("lang.advantage") }}</h2>
          <p>{{ $t("lang.advantage1") }}</p>
        </div>
        <!-- <div class="row" style="font-size: 20px;color: #333;font-weight: 600;">
          {{$t('lang.advantage')}}
        </div> -->
        <div class="wrap-row" style="margin-bottom: 25px;">
          <div class="col-no adv-box">
            <img src="../../assets/img/icon1.png" />
            <div class="adv-text" v-html="$t('lang.advtext1')">
              {{ $t("lang.advtext1") }}
            </div>
          </div>
          <div class="col-no adv-box">
            <img src="../../assets/img/icon2.png" />
            <div class="adv-text" v-html="$t('lang.advtext2')">
              {{ $t("lang.advtext2") }}
            </div>
          </div>
          <div class="col-no adv-box">
            <img src="../../assets/img/icon3.png" />
            <div class="adv-text" v-html="$t('lang.advtext3')">
              {{ $t("lang.advtext3") }}
            </div>
          </div>
          <div class="col-no adv-box">
            <img src="../../assets/img/icon4.png" />
            <div class="adv-text" v-html="$t('lang.advtext4')">
              {{ $t("lang.advtext4") }}
            </div>
          </div>
          <div class="col-no adv-box">
            <img src="../../assets/img/icon5.png" />
            <div class="adv-text" v-html="$t('lang.advtext5')">
              {{ $t("lang.advtext5") }}
            </div>
          </div>
          <div class="col-no adv-box">
            <img src="../../assets/img/icon6.png" />
            <div class="adv-text" v-html="$t('lang.advtext6')">
              {{ $t("lang.advtext6") }}
            </div>
          </div>
        </div>
      </div>
      <div class="foot-box">
        <div
          class="row"
          style="width: 1200px; margin: auto; justify-content: space-between;"
        >
          <div class="col-no" style="margin-top: 15px;">
            <span
              style="
                color: ##2d2d2d;
                font-size: 30px;
                font-weight: 500;
                text-align: center;
                padding-bottom: 10px;
              "
              >{{ $t("lang.contactus") }}</span
            >
            <span class="foot-text"
              >{{ $t("lang.add") }}：{{ $t("lang.addtext") }}</span
            >
            <span class="foot-text"
              >{{ $t("lang.tel") }}：0086-021-54871771</span
            >
            <span class="foot-text"
              >{{ $t("lang.fex") }}：0086-021-54871772</span
            >
            <span class="foot-text">E-mail：xinlong@china-cabletie.com</span>
          </div>
          <div
            class="item-no"
            style="
              display: block;
              width: 400px
              align-items: center;
              padding-top: 45px;
            "
          >
            <img
              src="../../assets/img/qrcode.png"
              style="
                display: block;
                width: 159px;
                height: 159px;
                margin: 0 auto;
              "
            />
            <p
              style="
                margin-top: 32px;
                font-size: 20px;
                color: #2d2d2d;
                text-align: center;
              "
            >
              {{ $t("lang.guanzhu") }}
            </p>
          </div>
        </div>
        <div style="text-align: center;">
          <a href="https://www.miit.gov.cn/">  沪ICP备13041438号</a>
        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./nav.vue";

export default {
  name: "App",
  components: {
    Nav,
  },
  data() {
    return {
      swiperIndex: 0,
      bannerForm: [],
      productList: [],
      langCn: "",
      langEn: "",
    };
  },
  methods: {
    route(name) {
      window.scrollTo(0,0);
      if (name === 3) {
        this.$router.push("aboutus");
      } else if (name === 1) {
        this.$router.push("index");
      } else if (name === 2) {
        this.$router.push("news");
      } else if (name === 4) {
        this.$router.push("newproduct");
      } else if (name === 5) {
        this.$router.push("download");
      }
    },
    toCN() {
      this.$i18n.locale = "zh-CN";
      localStorage.setItem("lang", "cn");
      location.reload();
    },
    toEN() {
      this.$i18n.locale = "en-US";
      localStorage.setItem("lang", "en");
      location.reload();
    },
    toFilter() {
      window.scrollTo(0,0);
      this.$router.push("filter");
    },
    toClass(item) {
      window.scrollTo(0,0);
      this.$util.toClassify(item);
      this.$router.push("classify");
    },
    getBannerList() {
      var self = this;
      this.$api.api.getBanner().then(function(response) {
        if (response.data.code === 200) {
          self.bannerForm = response.data.data;
        } else {
          self.$toast(response.data.msg);
        }
      });
    },
    getProductList() {
      let self = this;
      this.$api.api.listAllPro().then(function(response) {
        if (response.data.code === 200) {
          if (response.data.data.length < 8) {
            self.productList = response.data.data;
          } else {
            for (let i = 0; i < 8; i++) {
              self.productList.push(response.data.data[i]);
            }
          }
        } else {
          self.$toast(response.data.msg);
        }
      });
    },
  },
  mounted() {
    this.getBannerList();
    this.getProductList();
    if (localStorage.getItem("lang") === "cn") {
      this.langCn = "#2d8cf0";
      this.langEn = "#333";
    } else {
      this.langEn = "#2d8cf0";
      this.langCn = "#333";
    }
  },
};
</script>
<style>
.ivu-carousel .ivu-carousel-arrow {
  display: none;
}
.ivu-carousel .ivu-carousel-dots li {
  padding: 0 40px;
}
.ivu-carousel .ivu-carousel-dots li button {
  height: 16px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
}
.ivu-carousel .ivu-carousel-dots li.ivu-carousel-active > button {
  width: 16px;
  background: rgba(240, 17, 17, 0.5);
}
</style>
<style scoped>
.main-content {
  min-height: 100%;
  width: 100%;
  min-width: 1200px;
  margin: 0 auto;
  display: block;
  position: absolute;
  margin-top: 135px;
  /* background: #f7f7f7; */
}

.banner-box {
  overflow: hidden;
}

.foot-box {
  /* height: 211px; */
  width: 100%;
  background-color: #f0f0f0;
  justify-content: space-between;
  margin-top: 45px;
  padding: 15px 30px;
}

.foot-text {
  color: #2d2d2d;
  font-size: 20px;
  margin-top: 20px;
}

.center-body {
  min-width: 1200px;
  margin: 0 auto;
}

.ivu-menu-horizontal.ivu-menu-light:after {
  background: none;
}

.ivu-menu-horizontal .ivu-menu-item,
.ivu-menu-horizontal .ivu-menu-submenu {
  min-width: 120px;
  text-align: center;
}

.ivu-menu-light {
  background: none;
}

.prduct-box {
  width: 1200px;
  margin: 0px auto 0;
  padding: 15px;
}
.prduct-box .title {
  text-align: center;
  position: relative;
  margin: 30px 0 40px;
}
.prduct-box .title h2 {
  font-size: 24px;
  color: #333333;
  font-weight: 600;
  padding-bottom: 10px;
}
.prduct-box .title p {
  font-size: 16px;
  color: #666666;
  font-weight: 400;
}
.prduct-box .title span {
  display: block;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  font-weight: 400;
  position: absolute;
  right: 0;
  bottom: 20px;
}
.prduct-box .title span i {
  position: relative;
  top: -2px;
}
.auth {
  width: 100%;
  background-image: url("../../assets/img/auth.png");
  background-size: cover;
}
.aut-box {
  width: 11%;
  margin: 0 7%;
  margin-top: 20px;
  justify-content: center;
}

.adv-box {
  width: 27.3%;
  margin: 0 3%;
  margin-top: 50px;
  justify-content: center;
}
.adv-box img {
  width: 160px;
  height: 160px;
  margin: 0 auto 44px;
}
.adv-text {
  line-height: 2;
  width: 100%;
  height: 100%;
  color: #333333;
  font-size: 16px;
  text-align: center;
  margin-bottom: 10px;
  font-weight: 400;
}
</style>
